import type { PartialPageProps, Props } from '@/types/cms/magnolia';
import type { ApiAccommodation } from '../../api/model';

export const getGlobalPageProps = (props?: PartialPageProps) => {
  return {
    magnoliaHostClient: props?.magnoliaHostClient,
    magnoliaApiBase: props?.magnoliaApiBase,
    magnoliaContext: props?.magnoliaContext,
    isProduction: props?.isProduction,
    isAuthor: props?.isAuthor,
    resolvedUrl: props?.resolvedUrl,
    rootNodePath: props?.rootNodePath,
    locale: props?.locale,
    siteConfig: {
      parameters: props?.siteConfig?.parameters,
      name: props?.siteConfig?.name
    },
    albConfig: props?.albConfig,
    currentHost: props?.currentHost,
    product: {
      overviewHeadline: props?.product?.overviewHeadline,
      productTitle: props?.product?.productTitle,
      metaInformation: { metaTitle: props?.product?.metaInformation?.metaTitle },
      travelTypes: props?.product?.travelTypes?.map(travelType => ({
        name: travelType.name
      })),
      name: props?.product?.name
    },
    translationsVersion: props?.translationsVersion,
    page: {
      'mgnl:template': props?.page?.['mgnl:template'],
      title: props?.page?.title,
      '@id': props?.page?.['@id']
    },
    city: {
      name: props?.city?.name,
      metaInformation: { metaTitle: props?.city?.metaInformation?.metaTitle }
    },
    country: {
      name: props?.country?.name,
      metaInformation: { metaTitle: props?.country?.metaInformation?.metaTitle }
    },
    continent: {
      name: props?.continent?.name,
      metaInformation: { metaTitle: props?.continent?.metaInformation?.metaTitle }
    },
    ship: {
      name: props?.ship?.name,
      metaInformation: { metaTitle: props?.ship?.metaInformation?.metaTitle }
    },
    travelType: {
      name: props?.travelType?.name
    }
  };
};

export const getAccommodationContent = (accommodation?: ApiAccommodation, pageProps?: Props) => {
  return {
    accommodation: {
      id: accommodation?.id,
      descriptionBottom: accommodation?.descriptionBottom,
      ...(!!accommodation?.relatedShip
        ? {
            relatedShip: {
              metaInformation: {
                displayUrl: accommodation?.relatedShip?.metaInformation?.displayUrl
              }
            }
          }
        : {}),
      images: accommodation?.images,
      name: accommodation?.name,
      shortDescription: accommodation?.shortDescription,
      numberOfStars: accommodation?.numberOfStars,
      address: accommodation?.address,
      moreInformation: accommodation?.moreInformation,
      descriptionTopRight: accommodation?.descriptionTopRight,
      accommodationType: accommodation?.accommodationType
    },
    pageProps: {
      albConfig: { context: pageProps?.albConfig?.context },
      currentHost: pageProps?.currentHost,
      siteConfig: {
        parameters: { shipPage: pageProps?.siteConfig?.parameters?.shipPage }
      },
      rootNodePath: pageProps?.rootNodePath
    }
  };
};
